import { gql } from 'graphql-request';

export const ProfileFragment = gql`
  fragment Profile on User {
    id
    intercomUserHash
    name
    tier
    magicFileCreditsRemaining
    status
    avatar
    email
    emailVerified
    campaign
    identityStrategies
    preferredPlatform
    suspendedAt
    rolePermissions {
      owner
      editor
      viewer
      public
    }
    settings {
      name
      value
    }
    organizations {
      id
      name
      type
      memberCount
      seatLimit
      seatTier
      inheritedSeatTier
      effectiveTier
      role
      createdAt
      subscriptionStatus
      subscriptionPlan
      subscriptionSource
      subscriptionCurrentPeriodEnd
      subscriptionCancelAtPeriodEnd
      subscriptionId
      seatPacks
      pendingSeatPacks
      pendingSeatLimit
    }
  }
`;
